import { FunctionComponent } from "react";
import ModalOpen from "./components/modal";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button, CircularProgress } from "@mui/material";

interface ModalExportarProps {
  callDownloadPdf: VoidFunction
  callDownloadExcel: VoidFunction
  idLoadingData?: boolean
}

const ModalExportar: FunctionComponent<ModalExportarProps> = ({ callDownloadExcel, callDownloadPdf, idLoadingData = false }) => {

  if (idLoadingData) {
    return <Button><CircularProgress size={'20px'} /></Button>
  }

  return (<>
    <ModalOpen buttonStyle={{
      variant: "outlined", startIcon: <CloudUploadIcon />, sx: {
        '@media (max-width: 600px)': {
          '> p': {
            display: 'none'
          }
        }
      }
    }} title="Exportar">
      <>
        <section style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5, height: 50, borderBottom: '1px solid #ccc' }}>
          <h2>Exportar</h2>
        </section>
        <section style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5, height: 'calc(100% - 60px)', gap: 10 }}>
          <Button variant="contained" size="large" color="success" onClick={callDownloadExcel}>
            <p style={{ color: '#fff' }}>EXCEL</p>
          </Button>
          <Button variant="contained" size="large" color="error" >
            <p style={{ color: '#fff' }} onClick={callDownloadPdf}>PDF</p>
          </Button>
        </section>
      </>
    </ModalOpen>
  </>);
}

export default ModalExportar;
